var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFedex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#472F91",
    fillRule: "nonzero",
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.1 313.8l-16.6-18.6-16.5 18.6h-34.7l33.9-38.1-33.9-38.1h35.8l16.8 18.6 16.2-18.6h34.5l-33.8 38 34.3 38.2h-36zm-134.4 0v-120h66.6v26.8h-38.4v17h38.4v25.8h-38.4V287h38.4v26.8h-66.6z",
    fill: "#F60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.6 193.8v49.1h-.3c-6.2-7.2-14-9.6-23-9.6-18.6 0-32.5 12.8-37.2 29.7-5.5-18.5-19.8-30-41.3-30-17.4 0-31 8-38.1 20.8v-16.1H84.8v-17.1h39v-26.8H52.9v120h31.9v-50.5h32c-1 3.7-1.6 7.6-1.6 11.9 0 25 19.1 42.6 43.5 42.6 20.5 0 34.1-9.6 41.2-27.2h-27.3c-3.7 5.3-6.5 6.8-13.9 6.8-8.6 0-16-7.5-16-16.3h55.8c2.4 19.9 17.8 37 39 37 9.2 0 17.6-4.5 22.7-12.1h.3v7.8h28.1v-120h-28zm-117 69.9c1.8-7.6 7.7-12.6 15.1-12.6 8.1 0 13.7 4.8 15.2 12.6h-30.3zm99.9 31.9c-10.4 0-16.8-9.7-16.8-19.7 0-10.8 5.6-21.1 16.8-21.1 11.6 0 16.2 10.4 16.2 21.1.1 10.2-4.8 19.7-16.2 19.7z",
    fill: "#FDFDFE"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFedex);
export default __webpack_public_path__ + "static/media/fedex.ce6a92598a9e2dc2264bec0912b0b751.svg";
export { ForwardRef as ReactComponent };